<template>
  <div
    class="full-screen-video"
    :class="{ '--background-video': !props.overlayFullVideo }"
    @mousemove="moveCursor"
    @click="onQuickView"
    @mouseleave="resetCursor"
  >
    <div class="full-screen-video__wrap">
      <!-- Video preview -->
      <div class="full-screen-video__preview__video">
        <WidgetVideo
          class="full-screen-video__preview__video__player is-cover"
          :videoUrl="actualVideoSource"
          :loop="true"
          :forcePlay="true"
          :autoplay="true"
          :muted="isPreviewVideoMuted"
          :controls="false"
        />
      </div>

      <!-- Bottone Play -->
      <button
        v-if="props.overlayFullVideo"
        ref="magnetic"
        class="full-screen-video__play"
      >
        <svg viewBox="0 0 64 64" class="play-icon">
          <defs>
            <mask id="playMask">
              <rect width="64" height="64" fill="white" />
              <polygon points="26,20 44,32 26,44" fill="black" />
            </mask>
          </defs>
          <circle cx="32" cy="32" r="30" fill="#ff6d03" mask="url(#playMask)" />
        </svg>
      </button>

      <!-- Bottone Mute / Unmute -->
      <button
        v-if="showMuteUnmute && !props.overlayFullVideo && isPreviewVideoMuted"
        class="full-screen-video__mute"
      >
        <img
          src="@/assets/img/ico/ico-audio-off.svg"
          width="57"
          height="55"
          alt="Mute / Unmute"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetFullScreenVideo',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  previewVideo: {
    type: String,
    required: true,
  },
  previewVideoMobile: {
    type: String,
  },
  overlayFullVideo: {
    type: String,
  },
  showMuteUnmute: {
    type: Boolean,
    default: false,
  },
})

const touch = ref(false)

const magnetic = ref(null)
const quickview = useState('quickview', () => null)
const matchMediaTablet = useHelpers().evalMatchMedia('(min-width: 768px)')
const isPreviewVideoMuted = ref(true)

const moveCursor = (event) => {
  if (touch.value || !magnetic.value || !props.overlayFullVideo) return

  const { clientX, clientY } = event
  const { height, width, left, top } = magnetic.value.getBoundingClientRect()
  const x = clientX - (left + width / 2)
  const y = clientY - (top + height / 2)
  xTo(x)
  yTo(y)
}

const resetCursor = () => {
  xTo(0)
  yTo(0)
}

let xTo, yTo

const actualVideoSource = computed(() => {
  if (!props.previewVideoMobile) return props.previewVideo

  if (matchMediaTablet.value) {
    return props.previewVideo
  } else {
    return props.previewVideoMobile
  }
})

onMounted(async () => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints

  xTo = gsap.quickTo(magnetic.value, 'x', {
    duration: 1,
    ease: 'elastic.out(1, 0.3)',
  })
  yTo = gsap.quickTo(magnetic.value, 'y', {
    duration: 1,
    ease: 'elastic.out(1, 0.3)',
  })

  if (props.overlayFullVideo && magnetic.value) {
    magnetic.value.addEventListener('mousemove', moveCursor)
    magnetic.value.addEventListener('mouseleave', resetCursor)
  }
})

onUnmounted(() => {
  if (magnetic.value) {
    magnetic.value.removeEventListener('mousemove', moveCursor)
    magnetic.value.removeEventListener('mouseleave', resetCursor)
  }
})
const onQuickView = (e) => {
  if (props.overlayFullVideo) {
    quickview.value = props.overlayFullVideo
  } else if (props.showMuteUnmute) {
    const videoEl = document.querySelector(
      '.full-screen-video__preview__video video'
    )

    if (videoEl) {
      isPreviewVideoMuted.value = !isPreviewVideoMuted.value
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
